import React, { useState, useEffect } from "react";
import "../../css/testContainer.css";

const TestContainer = ({
  title,
  notification,
  handleNextTest,
  renderedQuestions,
  testDuration,
  gradeTest,
}) => {
  const [localRemainingTime, setLocalRemainingTime] = useState(testDuration);
  const [isTimeUp, setIsTimeUp] = useState(false);

  const userRole = localStorage.getItem("userRole");
  const userName = localStorage.getItem("userName") || "";
  const canUseNextQuestionButton =
    userRole === "9" ||
    userName.includes("デモユーザ") ||
    userName === "末吉　元気";

  // タイマーのカウントダウン処理
  useEffect(() => {
    if (localRemainingTime > 0 && !isTimeUp) {
      const timer = setInterval(() => {
        setLocalRemainingTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setIsTimeUp(true);
            gradeTest();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [localRemainingTime, isTimeUp, gradeTest]);

  // タイマーを強制的に0に設定
  const resetTimerToZero = () => {
    setLocalRemainingTime(0);
    setIsTimeUp(true);
    gradeTest();
  };

  return (
    <div className="test-container">
      <h1>{title}</h1>
      <div>
        {isTimeUp ? (
          <div className="overlay">
            <div className="notification">
              <h2>{notification}</h2>
              <button className="next-test-button" onClick={handleNextTest}>
                次に進む
              </button>
            </div>
          </div>
        ) : (
          <div className="questions-container">{renderedQuestions}</div>
        )}
      </div>
      {canUseNextQuestionButton && (
        <>
          <div className="timer">残り時間: {localRemainingTime}秒</div>
          <div className="next-button">
            <button className="reset-timer-button" onClick={resetTimerToZero}>
              次の問題に進む
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default TestContainer;
